import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { NavigateRouting } from '@core/configs';
import { checkUrlIsAllowed, getFirstURL } from '@core/helper';
import { AuthService } from '@core/services/apis';

@Injectable()
export class TokenGuard implements CanActivate {
  isActive = false;
  constructor(private _authService: AuthService, private _router: Router) { }

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    const accessTokenParam = route.queryParams['accessToken'] || null;
    const refreshTokenParam = route.queryParams['refreshToken'] || null;
    if (!accessTokenParam && this._authService.loggedIn() && !this.isActive) {
      this.isActive = true;
      if (!checkUrlIsAllowed(route)) {
        // in case user is logged-in and open new tab with endpoint '/'
        const url = getFirstURL();
        this._router.navigate([url]);
      }
      return true;
    }
    try {
      if (accessTokenParam && refreshTokenParam) {
        const userSessionObject = {
          accessToken: accessTokenParam,
          refreshToken: refreshTokenParam,
        };
        await this._authService.loginByToken(userSessionObject);
        const url = getFirstURL();
        this._router.navigate([url]);
      } else if (!this._authService.loggedIn()) {
        this._router.navigate([NavigateRouting.authConsoleLogin]);
        this._authService.logout().then();
        return false;
      }
      return true;
    } catch (err) {
      this._router.navigate([NavigateRouting.authConsoleLogin]);
      return false;
    }
  }
}
